﻿class BrowserDetect {
  constructor() {
    this.knownBrowsers = [
      {
        string: navigator.userAgent,
        subString: "Edge",
        identity: "Edge",
        versionPrefix: "Edge"
      },
      {
        string: navigator.userAgent,
        subString: "Edg",
        identity: "Edge",
        versionPrefix: "Edg"
      },
      {
        string: navigator.userAgent,
        subString: "OPR",
        identity: "Opera",
        versionPrefix: "OPR"
      },
      {
        prop: window.opera,
        identity: "Opera",
        versionPrefix: "Version"
      },
      {
        string: navigator.userAgent,
        subString: "Chrome",
        identity: "Chrome"
      },
      {
        string: navigator.userAgent,
        subString: "OmniWeb",
        versionPrefix: "OmniWeb/",
        identity: "OmniWeb"
      },
      {
        string: navigator.userAgent,
        subString: "Safari",
        identity: "Safari",
        versionPrefix: "Version"
      },
      {
        string: navigator.vendor,
        subString: "Apple",
        identity: "Safari",
        versionPrefix: "Version"
      },
      {
        string: navigator.vendor,
        subString: "iCab",
        identity: "iCab"
      },
      {
        string: navigator.vendor,
        subString: "KDE",
        identity: "Konqueror"
      },
      {
        string: navigator.userAgent,
        subString: "Firefox",
        identity: "Firefox"
      },
      {
        string: navigator.vendor,
        subString: "Camino",
        identity: "Camino"
      },
      {    // for newer Netscapes (6+)
        string: navigator.userAgent,
        subString: "Netscape",
        identity: "Netscape"
      },
      {
        string: navigator.userAgent,
        subString: "IEMobile",
        identity: "Explorer Mobile",
        versionPrefix: "IEMobile"
      },
      {
        string: navigator.userAgent,
        subString: "MSIE",
        identity: "Explorer",
        versionPrefix: "MSIE"
      },
      {
        string: navigator.userAgent,
        subString: "Trident",
        identity: "Explorer",
        versionPrefix: "rv"
      },
      {
        string: navigator.userAgent,
        subString: "Gecko",
        identity: "Mozilla",
        versionPrefix: "rv"
      },
      {     // for older Netscapes (4-)
        string: navigator.userAgent,
        subString: "Mozilla",
        identity: "Netscape",
        versionPrefix: "Mozilla"
      }
    ];

    this.knownOpSystems = [
      {
        string: navigator.userAgent,
        subString: "Windows Phone",
        identity: "Windows Phone"
      },
      {
        string: navigator.platform,
        subString: "Win",
        identity: "Windows"
      },
      {
        string: navigator.platform,
        subString: "Mac",
        identity: "Mac"
      },
      {
        string: navigator.userAgent,
        subString: "iPad",
        identity: "iPad"
      },
      {
        string: navigator.userAgent,
        subString: "iPhone",
        identity: "iPhone"
      },
      {
        string: navigator.userAgent,
        subString: "Android",
        identity: "Android"
      },
      {
        string: navigator.platform,
        subString: "Linux",
        identity: "Linux"
      }
    ];
  }

  detectItemInArray(data) {
    for (let i = 0; i < data.length; i++) {
      const dataString = data[i].string;
      const dataProp = data[i].prop;
      const prefix = data[i].versionPrefix || data[i].identity;
      if (dataString) {
        if (dataString.indexOf(data[i].subString) !== -1) {
          return {
            result: data[i].identity,
            versionPrefix: prefix
          };
        }
      } else if (dataProp) {
        return {
          result: data[i].identity,
          versionPrefix: prefix
        };
      }
    }
    return {
      result: "Undetected",
      versionPrefix: null
    };
  }

  searchVersion(dataString, prefix) {
    const index = dataString.indexOf(prefix);
    if (index == -1)
      return;
    return parseFloat(dataString.substring(index + prefix.length + 1));
  }

  detectOSCategory(OS) {
    switch (OS) {
      case "Windows":
      case "Windows Phone":
      case "Mac":
      case "iPad":
      case "iPhone":
      case "Android":
      case "Linux":
        return OS;
      default:
        return "Unknown";
    }
  }

  isIOS() {
    if (/iPad|iPhone|iPod/.test(navigator.platform)) {
      return true;
    } else {
      return navigator.maxTouchPoints &&
        navigator.maxTouchPoints > 2 &&
        /MacIntel/.test(navigator.platform);
    }
  }

  isIpadOS() {
    return navigator.maxTouchPoints &&
      navigator.maxTouchPoints > 2 &&
      /MacIntel/.test(navigator.platform);
  }

  refresh() {
    let item = this.detectItemInArray(this.knownBrowsers);
    this.browser = item.result;
    this.version = this.searchVersion(navigator.userAgent, item.versionPrefix)
      || this.searchVersion(navigator.appVersion, item.versionPrefix)
      || 0;
    item = this.detectItemInArray(this.knownOpSystems);
    this.OS = item.result;
    if (this.OS === 'Mac') {
      if (this.isIpadOS) {
        this.OS = 'iPad';
      } else if (this.isIOS()) {
        this.OS = 'iPhone';
      }
    }
    this.OSCategory = this.detectOSCategory(this.OS);
  }
}

class BrowserDetector {
  constructor() {
  }

  refresh(ua) {
    // Defaults
    this.browser = "Unknown";
    this.platform = "Unknown";
    this.version = "";
    this.majorver = "";
    this.minorver = "";

    var uaLen = ua.length;

    // ##### Split into stuff before parens and stuff in parens
    var preparens = "";
    var parenthesized = "";

    var i = ua.indexOf("(");
    var j = 0;
    if (i >= 0) {
      preparens = ua.substring(0, i).trim();
      parenthesized = ua.substring(i + 1, uaLen);
      j = parenthesized.indexOf(")");
      if (j >= 0)
        parenthesized = parenthesized.substring(0, j);
    }
    else
      preparens = ua;

    // ##### First assume browser and version are in preparens
    // ##### override later if we find them in the parenthesized stuff
    var browVer = preparens;

    var tokens = parenthesized.split(";");
    var token = "";
    // # Now go through parenthesized tokens
    for (i = 0; i < tokens.length; i++) {
      token = tokens[i].trim();
      //## compatible - might want to reset from Netscape
      if (token == "compatible") {
        //## One might want to reset browVer to a null string
        //## here, but instead, we'll assume that if we don't
        //## find out otherwise, then it really is Mozilla
        //## (or whatever showed up before the parens).
        //## browser - try for Opera or IE
      }
      else if (token.indexOf("MSIE") >= 0)
        browVer = token;
      else if (token.indexOf("Opera") >= 0)
        browVer = token;
      //'## platform - try for X11, SunOS, Win, Mac, PPC
      else if ((token.indexOf("X11") >= 0) || (token.indexOf("SunOS") >= 0) || (token.indexOf("Linux") >= 0))
        this.platform = "Unix";
      else if (token.indexOf(/*"Win"*/"Windows") >= 0) // Changed from "Win" to "Windows" by Tor because IE9 64-bit reports multiple strings starting with "Win"
        this.platform = token;
      else if ((token.indexOf("Mac") >= 0) || (token.indexOf("PPC") >= 0))
        this.platform = token;
      else if (token.indexOf("rv:") >= 0)
        browVer = token;
    }

    var msieIndex = browVer.indexOf("MSIE");
    if (msieIndex >= 0)
      browVer = browVer.substring(msieIndex, browVer.length);

    var leftover = "";
    if (browVer.substring(0, "Mozilla".length) == "Mozilla") {
      var edgeNdx = ua.indexOf("Edg");
      if (edgeNdx > -1) {
        this.browser = "Edge";
        leftover = ua.substring(edgeNdx + "Edg".length + 1, ua.length);
      } else {
        var chromeNdx = ua.indexOf("Chrome");
        if (chromeNdx > -1) {
          this.browser = "Chrome";
          leftover = ua.substring(chromeNdx + "Chrome".length + 1, ua.length);
        } else {
          this.browser = "Netscape";
          leftover = browVer.substring("Mozilla".length + 1, browVer.length);
        }
      }
    } else if (browVer.substring(0, "Lynx".length) == "Lynx") {
      this.browser = "Lynx";
      leftover = browVer.substring("Lynx".length + 1, browVer.length);
    } else if (browVer.substring(0, "MSIE".length) == "MSIE") {
      this.browser = "IE";
      leftover = browVer.substring("MSIE".length + 1, browVer.length);
    } else if (browVer.substring(0, "Microsoft Internet Explorer".length) == "Microsoft Internet Explorer") {
      this.browser = "IE";
      leftover = browVer.substring("Microsoft Internet Explorer".length + 1, browVer.length);
    } else if (browVer.substring(0, "Opera".length) == "Opera") {
      this.browser = "Opera";
      leftover = browVer.substring("Opera".length + 1, browVer.length);
    } else if ((browVer.substring(0, "rv:".length) == "rv:") && (ua.indexOf("Trident") > 0)) {
      this.browser = "IE";
      leftover = browVer.substring("rv:".length, browVer.length);
    }

    leftover = leftover.trim();

    // # Try to get version info out of leftover stuff
    i = leftover.indexOf(" ");
    if (i >= 0)
      this.version = leftover.substring(0, i);
    else
      this.version = leftover;
    j = this.version.indexOf(".");
    if (j >= 0) {
      this.majorver = this.version.substring(0, j);
      this.minorver = this.version.substring(j + 1, this.version.length);
    }
    else
      this.majorver = this.version;
  }
}

/**
 * This class is a merger of the BrowserDetect.js and BrowserDetector.js files found on the
 * LangloHomegPages web site. In addition the code has been modernized to fit into this class.
 */
export class ClientEnvInfo {
  constructor(autoRefresh) {
    this.browserDetect = new BrowserDetect();
    this.detector = new BrowserDetector();
    if (autoRefresh) {
      this.refresh();
    }
  }

  refresh() {
    const detect = this.browserDetect;
    detect.refresh();

    /* The BrowserDetector object has overlapping functionality with BrowserDetect, but provides
     * access to the platform version. We need that to distinguish Windows OS versions.
     * (BrowserDetect contains clearer information on OS (e.g. "Windows"), while BrowserDetector
     * contains clearer information on OS version (e.g. "Windows NT 5.1")). */

    const detector = this.detector;
    detector.refresh(navigator.userAgent);

    let osVersion = 0.0;
    let tokens = null;
    if (detect.OS === 'Windows') {
      tokens = detector.platform.split('Windows NT');
      if (tokens !== null && tokens.length === 2) {
        osVersion = parseFloat(tokens[1]);
      }
    } else if (detect.OS === 'Windows Phone') {
      tokens = detector.platform.split('Windows Phone OS');
      if (tokens !== null && tokens.length === 2) {
        osVersion = parseFloat(tokens[1]);
      } else {
        tokens = detector.platform.split('Windows Phone');
        if (tokens !== null && tokens.length === 2) {
          osVersion = parseFloat(tokens[1]);
        }
      }
    //} else if (detect.OS === 'Mac') {
    //  //
    }

    const browserCategory = detect.browser;
    this.device = {
      userAgent: navigator.userAgent,
      osCategory: detect.OSCategory,
      opSys: detect.OS,
      osVersion: osVersion,
      browserCategory: browserCategory,
      browser: detect.version > 0 ? browserCategory + ' ' + detect.version : browserCategory,
      browserVersion: detect.version,
      opSysAndVersion: osVersion ? detect.OS + ' ' + osVersion : detect.OS + ' (' + detector.platform + ')'
    };
  }
}